export const en = {
    header: {title: 'Sampling Session', samplingSession: 'Sampling Session'},
    join: {
        joinSession: 'Join session',
        enterSessionId: 'Enter session ID',
        connecting: 'Connecting to session…',
    },
    controls: {
        microphone: 'Microphone',
        camera: 'Camera',
        screenShareStart: 'Share screen',
        screenShareStop: 'Stop screen share',
        close: 'Close',
        leave: 'Hang up',
        notificationPlaceholder: 'Notification...',
        notify: 'Send',
        notificationInfo: 'Show a notification, e.g. a PIN code, to the person being tested',
        sending: 'Sending..',
    },
    status: {settingUp: 'Setting up…'},
    errors: {
        genericError: 'Something went wrong',
        tryAgainLater: 'Try again later or contact support',
    }
} as const;